import { NavigationContext, SelectInput } from '@kirz/mui-admin';
import { Add } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar as MuiAppBar,
  Box,
  IconButton,
  Toolbar,
  InputAdornment,
  MenuItem,
} from '@mui/material';
import { FolderOutline, RadioTower } from 'mdi-material-ui';
import React, { useContext, useState } from 'react';

import { TOOLBAR_HEIGHT } from 'constants/theme';
import { useAppState } from 'hooks/useAppState';

import { AppBarAccount } from './AppBarAccount';
import { UserCompanySelector } from './UserCompanySelector';

type Props = {
  onDrawerToggleClick: () => void;
};

export function AppBar({ onDrawerToggleClick }: Props) {
  const { setNavbarContainer } = useContext(NavigationContext);

  return (
    <>
      <MuiAppBar
        position="absolute"
        sx={{
          left: { xs: 0 },
          width: { xs: '100%' },
          zIndex: (theme) => theme.zIndex.drawer + 1,
          bgcolor: 'background.paper',
          height: TOOLBAR_HEIGHT,
          color: (theme) => theme.palette.text.primary,
        }}
      >
        <Toolbar
          sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}
        >
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: 'flex', lg: 'none' } }}
            onClick={onDrawerToggleClick}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={{
              flex: 1,
              pl: 0,
              pr: 5,
              display: 'flex',
              alignItems: 'center',
            }}
            ref={(ref) => {
              setNavbarContainer(ref as any);
            }}
          />
          <UserCompanySelector />
          <AppBarAccount />
        </Toolbar>
      </MuiAppBar>
    </>
  );
}
